<template>
  <!-- Responsive notifications layout -->
  <v-app>    
    <v-container>
      <v-row justify="center">
        <!-- Navigation Bar -->
        <v-col cols="12" class="mb-8">
          <!-- Implement Back Arrow functionality. Menu disabled. -->
          <NavBar />
        </v-col>
        <v-col cols="12"> 
          <h1 class="flex-box">
            Notifications
          </h1>
        </v-col>
        <!-- Notification space -->
        <v-col cols="12" class="notification-space">
          <NotificationItem 
            v-for="(notification, index) in notifications" 
            :key="index" 
            :notification="notification" 
          />
        </v-col>
      </v-row>
    </v-container>
    <!-- Footer -->
    <MENDFooter></MENDFooter>
  </v-app>
</template>

<script>
// Imported components present in each page.
//import MENDFooter from '../MENDFooter.vue';
import MENDFooter from '../MENDFooter.vue';
import NavBar from '../NavBar.vue';
import NotificationItem from './NotificationItem.vue';

import { ref } from 'vue';

export default {
  name: 'NotificationSpace',
  components: {
    NavBar,
    NotificationItem, // Register the component
    MENDFooter
  },
  setup() {
    const notifications = ref([]);

    // Example function to simulate receiving notifications
    function addNotification(newNotification) {
      notifications.value.push(newNotification);
    }

    // Simulate adding a notification every few seconds
    setInterval(() => {
      addNotification({ message: `New notification at ${new Date().toLocaleTimeString()}` });
    }, 5000);

    return { notifications };
  }
}
</script>

<style>
* {
  font-family: 'Montserrat';
}

.flex-box {
  display: flex;
  justify-content: center;
}

.notification-space {

  overflow-y: auto;
  
  padding: 10px;
  background-color: white;
}
</style>
